import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import styled from 'styled-components';

const StyledDatePicker = styled(DatePicker)`
	width: 100%;
`;

type Props = any & { onChange: (value: Date) => void };

export const CustomDatePicker: React.FC<Props> = props => {
	const { onChange, value } = props;

	return (
		<StyledDatePicker
			{...props}
			onChange={(v: any) => {
				// moment
				onChange(v?.toDate());
			}}
			value={value ? dayjs(value) : undefined}
		/>
	);
};
